import { render } from "./TestDrill.vue?vue&type=template&id=3907a988"
import script from "./TestDrill.vue?vue&type=script&lang=js"
export * from "./TestDrill.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__